import { DataTypeContent } from '@efdigital/ll-addon-data/data-types';
import type { File } from '@efdigital/ll-addon-data/types/content/file';
import type { Folder } from '@efdigital/ll-addon-data/types/content/folder';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import { cacheKeyFor, type Store } from '@warp-drive/core';
import { createRecord, findRecord } from '@warp-drive/utilities/json-api';

/**
 * Finds a folder by id
 * @param folderId - The id of the folder to find
 * @returns JSON API request to find the folder
 */
export function findFolderAndContents(folderId: string) {
  return findRecord<Folder>(DataTypeContent.Folder, folderId, {
    ...jsonApiOptions,
    include: ['files', 'folders'],
  });
}

/**
 * Finds a file by id
 * @param fileId - The id of the file to find
 * @returns JSON API request to find the file
 */
export function findFile(fileId: string) {
  return findRecord<File>(DataTypeContent.File, fileId, {
    ...jsonApiOptions,
  });
}

/**
 * Creates a file record via JSON:API POST
 * @param file - The file record to create
 * @param store - The store instance
 * @returns JSON API request to create the file
 */
export function createFile(file: File, store: Store) {
  const init = createRecord(file, {
    ...jsonApiOptions,
  });

  init.body = JSON.stringify({
    data: store.cache.peek(cacheKeyFor(file)),
  });

  init.headers.set('Content-Type', 'application/vnd.api+json');
  return init;
}
